// Migrated from app/assets/javascripts/idle.js
// Session idle timer and browser fingerprint tracking
import Fingerprint2 from 'fingerprintjs2'

var IDLE_TIMEOUT = 480; //seconds
var QUESTION_TIMEOUT = 30; //seconds
var _idleSecondsTimer = null;
var _idleSecondsCounter = 0;
var _sessionId = null;

function resetIdleCounter() {
  _idleSecondsCounter = 0;
}

function CheckIdleTime() {
  _idleSecondsCounter++;
  var oPanel = document.getElementById("debugIdleTimer");
  if (oPanel)
      oPanel.innerHTML = (_idleSecondsCounter) + "";
  if (_idleSecondsCounter >= IDLE_TIMEOUT) {
    window.clearInterval(_idleSecondsTimer);
    document.removeEventListener("onclick", resetIdleCounter);
    document.removeEventListener("mousemove", resetIdleCounter);
    document.removeEventListener("onkeypress", resetIdleCounter);

    _idleSecondsCounter = QUESTION_TIMEOUT;
    _idleSecondsTimer = window.setInterval(CheckQuestionTime, 1000);

    bootbox.alert({
        title: I18n.t("js.session_expiring_title"),
        closeButton: false,
        message: I18n.t("js.session_expiring_text"),
        buttons: {
          ok: {
            label: '<i class="fa fa-check"></i> ' + I18n.t("js.session_expiring_cta_confirm")
          }
        },
        callback: function () {
          window.clearInterval(_idleSecondsTimer);
          touchSession(true);
          _idleSecondsCounter = 0;
          _idleSecondsTimer = window.setInterval(CheckIdleTime, 1000);
        }
    });
  }
}

function CheckQuestionTime() {
  _idleSecondsCounter--;
  var oPanel = document.getElementById("SecondsUntilExpire");
  if (oPanel)
      oPanel.innerHTML = (_idleSecondsCounter) + "";
  if (_idleSecondsCounter === 0) {
    window.clearInterval(_idleSecondsTimer);
    sessionEnded();
  }
}

function sessionEnded() {
  bootbox.hideAll();
  destroySession();
  bootbox.alert({
    title: I18n.t("js.session_expired_title"),
    closeButton: false,
    message: I18n.t("js.session_expired_text"),
    buttons: {
      ok: {
        label: '<i class="fa fa-check"></i> ' + I18n.t("js.session_expired_cta")
      }
    },
    callback: function () {
      location.reload();
    }
  });
}

function generateBrowserSession() {
  var options = { excludes: {enumerateDevices: true, localStorage: true, sessionStorage: true} };
  Fingerprint2.get(options, function (components) {
    var values = components.map(function (component) { return component.value; });
    _sessionId = Fingerprint2.x64hash128(values.join(''), 31);

    // add value to the form
    var element = document.getElementById("sessionId");
    if (element)
      element.value = _sessionId;

    // debug info
    var oPanel = document.getElementById("debugSessionId");
    if (oPanel)
      oPanel.innerHTML = (_sessionId) + "";

    touchSession();
  });
}

function touchSession(restart) {
  var url = "/exchange/analytics/touch/" + _sessionId;
  if (restart) {
    url += "?restart=true";
  }
  httpRequest("POST", url);
}

function destroySession() {
  httpRequest("DELETE", "/exchange/analytics/destroy/" + _sessionId);
}

function httpRequest(method, url) {
  var xhttp = new XMLHttpRequest();
  xhttp.open(method, url, true);
  xhttp.send();
}

function hasClass(element, className) {
  return element.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className);
}


// main entry
window.addEventListener('load', function () {

  if (hasClass(document.getElementsByTagName('body')[0], 'session_timer')) {

    document.addEventListener("onclick", resetIdleCounter);
    document.addEventListener("mousemove", resetIdleCounter);
    document.addEventListener("onkeypress", resetIdleCounter);

    _idleSecondsTimer = window.setInterval(CheckIdleTime, 1000);

  }

  if (hasClass(document.getElementsByTagName('body')[0], 'session_tracker')) {

    if (window.requestIdleCallback) {
      requestIdleCallback(function () { generateBrowserSession(); });
    } else {
      setTimeout(function () { generateBrowserSession(); }, 500);
    }

  }

});
